import React, { ReactNode, useEffect, useLayoutEffect } from "react";
import { IStory } from "./IStories";
import StoryView from "./StoryView";
import localSitemap from "./sitemap.json";


interface ChatMateProps {
    stories: IStory[];
    story: IStory;
  }
  
 export const ChatMate: React.FC = () => {

    const [stories, setStories] = React.useState<IStory[]>([]);
    const [story, setStory] = React.useState<IStory>();
    const [sitemap, setSitemap] = React.useState<any>(localSitemap);

    const getStories = (includeHiddenStories = false): IStory[] => {
      return ((sitemap && sitemap.stories) || []).filter((eachStory: IStory) => {
        if (!includeHiddenStories && (eachStory.versionTags || []).includes('hidden')) {
          return false;
        }
        return true;
      }).sort((story1: IStory, story2: IStory) => {
        // Incase the Ordinal Value is left blank in the CMS, placing that story at end of the list
        const ordinal1 = story1.ordinal ?? Infinity;  
        const ordinal2 = story2.ordinal ?? Infinity; 
        
        return ordinal1 - ordinal2;
      });    
    };

    const getStoryFromIdentifier = (
      identifier: string,
      includeHiddenStories = false,
    ): IStory  => {
      return getStories(includeHiddenStories).find(
        (eachStory: IStory) => eachStory.storyIdentifier === identifier,
      ) || {} as IStory;
    };

    // useLayoutEffect(() => {
    //     const fetchSitemap = async () => {
    //       console.log('Fetching sitemap...');
    //         const sitemapUrl = 'https://conversations.test.movember.com/static/assets/en/sitemap.json';
    //         await fetch(sitemapUrl).then((response) => {
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //             }
    //             setSitemap(response.json());
    //                         })

    //     };

    //     fetchSitemap().catch((error) => {
    //         console.error('Error fetching sitemap:', error);
    //     });
    // }, [])

    useEffect(() => {
      if (sitemap) {
        const _stories = getStories(true);
        setStories(_stories);
        const _story = getStoryFromIdentifier('juggling-work-and-family', true);
        setStory(_story);
      }
    }, [sitemap]);


    return (
      <>
        {
          stories.length > 0 && story &&
          <StoryView stories={stories} story={story} />
        }

        <div>test</div>
      </>
    );
  };
  